const NAMESPACE = "communicationsCapsule";

const KEYS = {
    communicationsCapsuleTitle: "communicationsCapsuleTitle",
    communicationsTitleNonOwner: "communicationsTitleNonOwner",
    communicationsTitleOwner: "communicationsTitleOwner",
    viewButtonLabel: "viewButtonLabel",
    noDescriptionText: "noDescriptionText",
    deleteDraftButtonLabel: "deleteDraftButtonLabel",
    sendCommunicationText: "sendCommunicationText",
    descriptionHeader: "descriptionHeader",
    messageSubjectHeader: "messageSubjectHeader",
    sentTimestampHeader: "sentTimestampHeader",
    messageStatusDisplayHeader: "messageStatusDisplayHeader",
    emptyTableText: "emptyTableText",
    ownerNotNullText: "ownerNotNullText",
    ownerNullText: "ownerNullText",
    confirmDeletionDialogTitle: "confirmDeletionDialogTitle",
    deletionConfirmationMessage: "deletionConfirmationMessage",
    deletionConfirmationWithDescMessage: "deletionConfirmationWithDescMessage"
};

const MESSAGES = {
    [KEYS.communicationsCapsuleTitle]: {
        value: "Communications",
        comment: "Capsule title for user not project owner"
    },
    [KEYS.communicationsTitleNonOwner]: {
        value: "Communications Sent to Project Owner",
        comment: "Capsule title for user not project owner"
    },
    [KEYS.communicationsTitleOwner]: {
        value: "Communications Sent to {projectOwnerEmail}",
        comment: "Capsule title for user who is project owner"
    },
    [KEYS.viewButtonLabel]: {
        value: "View",
        comment: "View button label"
    },
    [KEYS.noDescriptionText]: {
        value: "No Description",
        comment: "Text to display if communication doesn't have description"
    },
    [KEYS.deleteDraftButtonLabel]: {
        value: "Delete draft",
        comment: "Delete draft button label"
    },
    [KEYS.sendCommunicationText]: {
        value: "Send communication",
        comment: "Text prompting user to send a communication"
    },
    [KEYS.descriptionHeader]: {
        value: "Description",
        comment: "Description column header"
    },
    [KEYS.messageSubjectHeader]: {
        value: "Subject",
        comment: "MessageSubject column header"
    },
    [KEYS.sentTimestampHeader]: {
        value: "Date",
        comment: "SentTimestamp column header"
    },
    [KEYS.messageStatusDisplayHeader]: {
        value: "Status",
        comment: "MessageStatusDisplay column header"
    },
    [KEYS.emptyTableText]: {
        value: "No communications have been sent for this project.",
        comment: "Text to let user know there are no communications for project"
    },
    [KEYS.ownerNotNullText]: {
        value: "{projectOwnerEmail} has not been sent any communications.",
        comment: "Text to display if no communications and the owner is not null."
    },
    [KEYS.ownerNullText]: {
        value: "The project owner has not been sent any communications.",
        comment: "Text to display if owner is null, race condition, and there are no communications"
    },
    [KEYS.confirmDeletionDialogTitle]: {
        value: "Confirm Deletion",
        comment: "Text for confirm deletion dialogue title"
    },
    [KEYS.deletionConfirmationMessage]: {
        value: "Are you sure you want to delete this unsent communication?",
        comment: "Text to ask user to confirm unsent communication deletion"
    },
    [KEYS.deletionConfirmationWithDescMessage]: {
        value: "Are you sure you want to delete the unsent communication {communicationDescription}?",
        comment: "Confirm with user they want to update deadline status"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
